import { Button } from '@givebutter/primitives/button';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getDataPoints from 'assets/js/pages/contacts/single/donor-search/getDataPoints';
import { useDeleteDonorSearch } from 'assets/js/pages/contacts/single/donor-search/useDeleteDonorSearch';
import { usePerformDonorSearch } from 'assets/js/pages/contacts/single/donor-search/usePerformDonorSearch';
import * as Tooltip from 'components/tooltip';
import { useCurrentContact } from 'customHooks/useCurrentContact';
import { DateTime } from 'luxon';

const Searched = () => {
    const { data: contact } = useCurrentContact();
    const donorSearchURL = `https://www.donorlead.net/profile/view/${contact.donorsearch?.ProfileID}`;

    const { mutateAsync: search, isPending: isSearchPending } = usePerformDonorSearch();
    const { mutateAsync: reset, isPending: isResetPending } = useDeleteDonorSearch();
    const isPending = isResetPending || isSearchPending;

    return (
        <div className="relative flex flex-grow flex-col justify-center gap-3">
            <div className="flex flex-col gap-4 px-0 pb-5 pt-2">
                {getDataPoints(contact).map((dp, index) => (
                    <div key={`${dp.label}-${index}`} className="flex gap-1.5">
                        <Tooltip.Root>
                            <Tooltip.Trigger asChild>
                                <p className="w-fit cursor-help text-sm font-medium text-gray-400 underline decoration-dashed">
                                    {dp.label}
                                </p>
                            </Tooltip.Trigger>
                            <Tooltip.Portal>
                                <Tooltip.Content inverse>
                                    <p>{dp.description}</p>
                                    <Tooltip.Arrow inverse />
                                </Tooltip.Content>
                            </Tooltip.Portal>
                        </Tooltip.Root>
                        <p className="w-fit text-gray-800">{dp.value || 'N/A'}</p>
                    </div>
                ))}
            </div>

            <a
                href={donorSearchURL}
                className="intercom-target-integrations flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3.5 py-2.5 text-center text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-900"
                target="_blank"
                rel="noopener noreferrer"
            >
                View in DonorSearch
            </a>

            <div className="mx-auto flex flex-col items-center">
                {isResetPending ? (
                    <FontAwesomeIcon icon={faSpinnerThird} spin />
                ) : (
                    <div className="flex gap-2">
                        <Button
                            variant="none"
                            onClick={() => search(true)}
                            disabled={isPending}
                            size="xs"
                            className="font-medium text-gray-500 underline"
                        >
                            {isSearchPending ? 'Refreshing...' : 'Refresh data'}
                        </Button>
                        <Button
                            variant="none"
                            onClick={() => reset()}
                            disabled={isPending}
                            size="xs"
                            className="font-medium text-gray-500 underline"
                        >
                            Start a new search
                        </Button>
                    </div>
                )}
                {contact.donorsearch_last_updated_at && (
                    <p className="text-xs text-gray-500">
                        Last updated{' '}
                        {DateTime.fromISO(contact.donorsearch_last_updated_at)
                            .setZone('utc')
                            .toLocaleString(DateTime.DATETIME_FULL)}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Searched;
